import { render, staticRenderFns } from "./CompetitorIcon.vue?vue&type=template&id=014346b8"
import script from "./CompetitorIcon.vue?vue&type=script&lang=ts"
export * from "./CompetitorIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports